import { IconButton, Tooltip, styled } from "@mui/material";
import clsx from "clsx";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { IWithClassName } from "../../../theme/default.theme";
import { RunStatus } from "../enum/run-status";
import { IListBuilderTableDto } from "../interface/dto/list-builder-table-list.dto";
import { listBuilderTableDuplicateAction } from "../redux/list-builder-table-page.action";

interface IOwnProps {
    listBuilder: IListBuilderTableDto;
}

const ListBuilderDuplicate = ({
    className,
    listBuilder,
}: IWithClassName & IOwnProps) => {
    const dispatch = useAppDispatch();
    const canCreateMoreListBuilders = useAppSelector(
        (state) =>
            state.listBuilderTable.listBuilderTable.canCreateMoreListBuilders,
    );

    const isRunStatusBlocking = listBuilder
        ? [RunStatus.Pending, RunStatus.Running].includes(
              listBuilder.lastRunStatus,
          ) && listBuilder.lastRunProgress < 100
        : true;

    const isButtonDisabled = !canCreateMoreListBuilders || isRunStatusBlocking;

    const handleDuplicateClick = () => {
        if (listBuilder) {
            dispatch(
                listBuilderTableDuplicateAction(listBuilder.listBuilderId),
            );
        }
    };

    return (
        <span className={className}>
            <Tooltip
                title={
                    canCreateMoreListBuilders
                        ? "Duplicate this List Builder"
                        : "You can't create more list builders"
                }
            >
                <span>
                    <IconButton
                        onClick={handleDuplicateClick}
                        aria-label="duplicate"
                        disabled={isButtonDisabled}
                        className={clsx({ disabledButton: isButtonDisabled })}
                    >
                        <img src="/assets/duplicate.svg" alt="Duplicate" />
                    </IconButton>
                </span>
            </Tooltip>
        </span>
    );
};

export default styled(ListBuilderDuplicate)(() => ({
    ".disabledButton": {
        opacity: 0.5,
    },
}));
